import config from "../../../_config/global";
import {
  IDeleteSingleArgs,
  IGetSingleArgs,
  IPageAndSearchArgs,
  IUpdateSingleArgs,
} from "../../../interfaces";
import { goFetch } from "../../../utilities/goFetch";

interface apiResponse {
  data: Object;
  message: string;
  success: boolean;
}

class Service {
  async getByPage({ search, pageNo }: IPageAndSearchArgs) {
    const faqs = (await goFetch(config.endpoints.faqs.getByPage)
      .withQueryParameters({
        search: search ?? "",
        pageSize: config.pageSize,
        pageNumber: pageNo || 1,
      })
      .get()) as any;
    const { paginatedResults, totalCount } = faqs?.data[0] || {};
    const itemCount = totalCount?.[0]?.count || 0;
    return {
      pageNo: pageNo,
      pageSize: config.pageSize,
      pageCount: Math.ceil(itemCount / config.pageSize),
      data: paginatedResults,
      itemCount,
    };
  }

 async getFaqs(active_only: boolean = false) {
    const faqs = (await goFetch(config.endpoints.faqs.getByPage)     
      .get()) as any;
    let paginatedResults: any[] = faqs?.data;

    if(active_only)
      paginatedResults = paginatedResults?.filter(role => role.is_active == true);
    
    return  paginatedResults as any[];
  }

  async getSingle({ key }: IGetSingleArgs) {
    const role = (await goFetch(`${config.endpoints.faqs.getSingle}`)
      .withQueryParameters({ id: key })
      .get()) as unknown as apiResponse;
    return role.data;
  }

  async create() {
    return (await goFetch(
      `${config.endpoints.faqs.add}`
    ).put()) as unknown as apiResponse;
  }

  async update({ key, ...rest }: IUpdateSingleArgs) {
    await goFetch(`${config.endpoints.faqs.update}`)
      .withBody({
        _id: key,
        ...rest,
      })
      .post();
  }

  async delete(key: IDeleteSingleArgs) {
    await goFetch(`${config.endpoints.faqs.delete}`)
      .withBody({ _id: key })
      .delete();
  }
}

export default new Service();
